__turbopack_context__.v({
  "airlineInfo": "xfRDdG_airlineInfo",
  "flightInfoFooter": "xfRDdG_flightInfoFooter",
  "flightInfoMain": "xfRDdG_flightInfoMain",
  "flightTypeTag": "xfRDdG_flightTypeTag",
  "footerTags": "xfRDdG_footerTags",
  "legBlock": "xfRDdG_legBlock",
  "locationBlock": "xfRDdG_locationBlock",
  "locationsColumn": "xfRDdG_locationsColumn",
  "remarksArea": "xfRDdG_remarksArea",
  "secondaryText": "xfRDdG_secondaryText",
  "separator": "xfRDdG_separator",
  "separatorBottom": "xfRDdG_separatorBottom",
  "separatorDot": "xfRDdG_separatorDot",
  "separatorIcon": "xfRDdG_separatorIcon",
  "separatorLine": "xfRDdG_separatorLine",
  "separatorMiddle": "xfRDdG_separatorMiddle",
  "separatorSpacer": "xfRDdG_separatorSpacer",
  "separatorTop": "xfRDdG_separatorTop",
  "timeBlock": "xfRDdG_timeBlock",
  "timeDate": "xfRDdG_timeDate",
  "timesColumn": "xfRDdG_timesColumn",
});
